import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Paper, Typography } from '@mui/material';
import { JOB_PORTAL_KEYS, NS } from '../../../../../i18n/constants/keys';

interface IJobDescriptionProps {
  htmlTemplate?: string;
}

export const JobDescription = ({ htmlTemplate }: IJobDescriptionProps) => {
  const { t } = useTranslation(NS.jobPortal);

  return (
    <Paper sx={{ p: 2.5 }}>
      <Typography variant="h2" sx={{ mb: 2 }}>
        {t(JOB_PORTAL_KEYS.details.jobDescription)}
      </Typography>
      <Box
          dangerouslySetInnerHTML={{ __html: htmlTemplate ?? '' }}
          sx={{
            color: 'text.primary',
            fontSize: '0.875rem',
            '& h1': { mb: 1.5, mt: 2.5, fontSize: '1.25rem', fontWeight: 800 },
            '& h2': { mb: 1, mt: 2, fontSize: '1.125rem', fontWeight: 700 },
            '& h3': { mb: 1, mt: 1.5, fontSize: '1rem', fontWeight: 700 },
            '& p': { mb: 1.5, lineHeight: 1.7 },
            '& ul': { mb: 1.5, mt: 0.5, pl: 2.5, listStyleType: 'disc' },
            '& li': { lineHeight: 1.7, mb: 0.5 },
            '& strong': { fontWeight: 700 },
          }}
      />
    </Paper>
  );
};
